import { InSessionPatientNoteWrapper as InSessionPatientNote } from '../patient-note/PatientNoteWrapper';
import { PatientNotePopoverControlButton } from './PatientNotePopoverControlButton';

export function PatientNotePopoverControlButtonWrapper() {
  return <PatientNotePopoverControlButton patientNoteComponent={InSessionPatientNote} />;
}
